import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ViewCommissionCompanyModal = ({ show, handleClose, company }) => {
    if (!company) return null;

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>View Commission Company Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-3">
                    <strong>Company ID:</strong> {company.id}
                </div>
                <div className="mb-3">
                    <strong>Company Name:</strong> {company.name}
                </div>
                {company.created_at && (
                    <div className="mb-3">
                        <strong>Created At:</strong> {new Date(company.created_at).toLocaleString()}
                    </div>
                )}
                {company.updated_at && (
                    <div className="mb-3">
                        <strong>Updated At:</strong> {new Date(company.updated_at).toLocaleString()}
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ViewCommissionCompanyModal;
